import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GetLocationCoordinate from './LocationCoordinate.graphql';

export const useLocationCoordinate = (options) =>
  useCustomQuery(GetLocationCoordinate, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'locationCoordinate',
  });
